// 出差申请单
export const list = [
  {
    //   我的出差申请单列表
    path: '/myApplyOrder',
    name: 'myApplyOrder',
    component: () => import('@/page/applyOrder/myApplyOrder'),
    meta: {
      title: '申请单列表'
    }
  }
]
export const hideList = [
  {
    //   创建出差申请单
    path: '/createApplyOrder',
    name: 'createApplyOrder',
    component: () => import('@/page/applyOrder/createApplyOrder'),
    meta: {
      title: '创建出差申请单'
    }
  },
  {
    //   修改出差申请单
    path: '/editApplyOrder',
    name: 'editApplyOrder',
    component: () => import('@/page/applyOrder/editApplyOrder'),
    meta: {
      title: '修改出差申请单'
    }
  },
  {
    //   出差申请单详情
    path: '/applyOrderDetail',
    name: 'applyOrderDetail',
    component: () => import('@/page/applyOrder/applyOrderDetail'),
    meta: {
      title: '出差申请单详情'
    }
  }
]
const applyOrderRouter = [
  {
    path: '/applyOrderIndex',
    name: 'applyOrderIndex',
    redirect: '/myApplyOrder',
    component: () => import('@/page/applyOrder/index'),
    children: list.concat(hideList)
  }
]

export default applyOrderRouter



// WEBPACK FOOTER //
// ./src/router/modules/applyOrder.js